import { View, Text, Alert } from "react-native";
import React from "react";
import { useNavigation } from "@react-navigation/native";

export default function BackButtonInTest() {
  const [text, setText] = React.useState(",jbkj");
  const hasUnsavedChanges = Boolean(text);
  const navigation = useNavigation();

  React.useEffect(
    () =>
      navigation.addListener("hardwareBackPress", (e) => {
        if (!hasUnsavedChanges) {
          // If we don't have unsaved changes, then we don't need to do anything
          return;
        }

        // Prevent default behavior of leaving the screen
        e.preventDefault();

        // Prompt the user before leaving the screen
        Alert.alert(
          "رها کردن آزمون ؟",
          "در صورتی که صفحه را ترک کنید جواب های شما ثبت نمیشود !",
          [
            { text: "رها نکن", style: "cancel", onPress: () => {} },
            {
              text: "رها کردن آزمون",
              style: "destructive",
              // If the user confirmed, then we dispatch the action we blocked earlier
              // This will continue the action that had triggered the removal of the screen
              onPress: () => navigation.navigate("Tests"),
            },
          ]
        );
      }),
    [navigation, hasUnsavedChanges]
  );
  return <View></View>;
}
